/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  PatientDetailResponse,
  PatientSearchFilterTokenPagedRequest,
  PatientSearchResultTokenPagedResult,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiPracticesPracticeIdPatientsPatientIdResponse200 = {
  data: PatientDetailResponse;
  status: 200;
};

export type getApiPracticesPracticeIdPatientsPatientIdResponse401 = {
  data: void;
  status: 401;
};

export type getApiPracticesPracticeIdPatientsPatientIdResponse403 = {
  data: void;
  status: 403;
};

export type getApiPracticesPracticeIdPatientsPatientIdResponse404 = {
  data: void;
  status: 404;
};

export type getApiPracticesPracticeIdPatientsPatientIdResponseSuccess =
  getApiPracticesPracticeIdPatientsPatientIdResponse200 & {
    headers: Headers;
  };
export type getApiPracticesPracticeIdPatientsPatientIdResponseError = (
  | getApiPracticesPracticeIdPatientsPatientIdResponse401
  | getApiPracticesPracticeIdPatientsPatientIdResponse403
  | getApiPracticesPracticeIdPatientsPatientIdResponse404
) & {
  headers: Headers;
};

export const getGetApiPracticesPracticeIdPatientsPatientIdUrl = (
  practiceId: string,
  patientId: string,
) => {
  return `/api/practices/${practiceId}/patients/${patientId}`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * Loads the selected patient for the CCoF view. Returns identification fields, the guarantor (with contact phone for the manual card capture flow), and a card-on-file slot.
 * @summary Retrieves a patient by id, scoped to the active practice.
 */
export const getApiPracticesPracticeIdPatientsPatientId = async (
  practiceId: string,
  patientId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiPracticesPracticeIdPatientsPatientIdResponseSuccess> => {
  return authenticatedClient<getApiPracticesPracticeIdPatientsPatientIdResponseSuccess>(
    getGetApiPracticesPracticeIdPatientsPatientIdUrl(practiceId, patientId),
    {
      ...options,
      method: "GET",
    },
  );
};

export type deleteApiPracticesPracticeIdPatientsPatientIdCardResponse204 = {
  data: void;
  status: 204;
};

export type deleteApiPracticesPracticeIdPatientsPatientIdCardResponse401 = {
  data: void;
  status: 401;
};

export type deleteApiPracticesPracticeIdPatientsPatientIdCardResponse403 = {
  data: void;
  status: 403;
};

export type deleteApiPracticesPracticeIdPatientsPatientIdCardResponse404 = {
  data: void;
  status: 404;
};

export type deleteApiPracticesPracticeIdPatientsPatientIdCardResponseSuccess =
  deleteApiPracticesPracticeIdPatientsPatientIdCardResponse204 & {
    headers: Headers;
  };
export type deleteApiPracticesPracticeIdPatientsPatientIdCardResponseError = (
  | deleteApiPracticesPracticeIdPatientsPatientIdCardResponse401
  | deleteApiPracticesPracticeIdPatientsPatientIdCardResponse403
  | deleteApiPracticesPracticeIdPatientsPatientIdCardResponse404
) & {
  headers: Headers;
};

export const getDeleteApiPracticesPracticeIdPatientsPatientIdCardUrl = (
  practiceId: string,
  patientId: string,
) => {
  return `/api/practices/${practiceId}/patients/${patientId}/card`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Deletes the stored card on file for a patient's guarantor.
 */
export const deleteApiPracticesPracticeIdPatientsPatientIdCard = async (
  practiceId: string,
  patientId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<deleteApiPracticesPracticeIdPatientsPatientIdCardResponseSuccess> => {
  return authenticatedClient<deleteApiPracticesPracticeIdPatientsPatientIdCardResponseSuccess>(
    getDeleteApiPracticesPracticeIdPatientsPatientIdCardUrl(
      practiceId,
      patientId,
    ),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export type postApiPracticesPracticeIdPatientsSearchResponse200 = {
  data: PatientSearchResultTokenPagedResult;
  status: 200;
};

export type postApiPracticesPracticeIdPatientsSearchResponse401 = {
  data: void;
  status: 401;
};

export type postApiPracticesPracticeIdPatientsSearchResponse403 = {
  data: void;
  status: 403;
};

export type postApiPracticesPracticeIdPatientsSearchResponseSuccess =
  postApiPracticesPracticeIdPatientsSearchResponse200 & {
    headers: Headers;
  };
export type postApiPracticesPracticeIdPatientsSearchResponseError = (
  | postApiPracticesPracticeIdPatientsSearchResponse401
  | postApiPracticesPracticeIdPatientsSearchResponse403
) & {
  headers: Headers;
};

export const getPostApiPracticesPracticeIdPatientsSearchUrl = (
  practiceId: string,
) => {
  return `/api/practices/${practiceId}/patients/search`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Searches for patients within the authorised practice.
Results are strictly scoped to the practice identified by practiceId.
Search criteria are submitted in the request body to prevent PHI from appearing in URLs or server access logs.
 */
export const postApiPracticesPracticeIdPatientsSearch = async (
  practiceId: string,
  patientSearchFilterTokenPagedRequest?: PatientSearchFilterTokenPagedRequest,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<postApiPracticesPracticeIdPatientsSearchResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return authenticatedClient<postApiPracticesPracticeIdPatientsSearchResponseSuccess>(
    getPostApiPracticesPracticeIdPatientsSearchUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(patientSearchFilterTokenPagedRequest),
    },
  );
};
